import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/login/page.tsx");
